/**
 * Display values for referral credits — single source of truth for
 * all user-facing referral copy across desktop. Update here, not at
 * call sites.
 *
 * Keep in sync with backend `referral_constants.py`
 * (`REFERRER_*_CREDIT_CENTS`, `ACTIVITY_REWARD_CREDIT_CENTS`).
 */
export const REFERRAL_CREDIT = {
  /** Activity-based reward — paid out after the referee uses LittleBird for 3 days. */
  ACTIVITY: '$20',
  /** Payment-based reward — paid out after the referee's first paid month. */
  PAYMENT: '$40',
} as const;

export const REFERRAL_BANNER_MIN_ACCOUNT_AGE_DAYS = 3;
